import utils from "../utils";

function initMenu() {
	var mainNav = document.getElementById("main-nav"),
		mainMenuToggler = document.getElementById("main-nav-toggler"),
		mainMenuCloser = document.getElementById("menu-closer"),
		menuArrows = document.querySelectorAll('.menu-item-has-children .menu-arrow'),
		htmlTag = document.getElementsByTagName("html")[0];

	mainMenuToggler.addEventListener("click", () => {
		let isOpen = mainNav.classList.contains("open");
		if (isOpen) {
			mainMenuToggler.setAttribute("aria-expanded", "false");
			mainNav.classList.remove("open");
			htmlTag.classList.remove("no-scroll");
		} else {
			mainMenuToggler.setAttribute("aria-expanded", "true");
			mainNav.classList.add("open");
			htmlTag.classList.add("no-scroll");
		}
	});

	mainMenuCloser.addEventListener("click", () => {
		mainMenuToggler.setAttribute("aria-expanded", "false");
		mainNav.classList.remove("open");
		htmlTag.classList.remove("no-scroll");
	});

	if(mainNav){

		var menuItemHasChildren = mainNav.querySelectorAll('.menu-item-has-children > a');

		if(menuItemHasChildren.length > 0){	
			utils.forEach(menuItemHasChildren, function (index, elem) {
				elem.addEventListener("click", function () {
					
					if(elem.parentElement.classList.contains('visible')){
						elem.parentElement.classList.remove('visible');
					} else {
						elem.parentElement.classList.add('visible');
					}
				})
			});
		}
	}

	manageSubMenus(menuArrows);

	window.addEventListener('resize', () => {
		
		manageSubMenus(menuArrows);
		
	});

}

function manageSubMenus(menuArrows){
	if(window.innerWidth < 1400){
		if(menuArrows.length > 0){
			utils.forEach(menuArrows, function (index, menuArrow) {
				menuArrow.addEventListener("click", function (event) {
					event.preventDefault();
					menuArrow.parentElement.parentElement.classList.toggle('open');
				})
			});
		}
	}
}

export default { initMenu };
